/* eslint-disable */

export function stickyHeader() {
    window.addEventListener("scroll", function () {
        var header = document.querySelector("#masthead");
        header.classList.toggle("sticky", window.scrollY > 0);

        // Toggle class on body
        document.body.classList.toggle("site-header-stuck", window.scrollY > 0);
    });
}
